import React, { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { toast } from "@/hooks/use-toast";

export default function JoinClub() {
  const [email, setEmail] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast({ title: "Enter a valid email", description: "We need a real one to send the code." });
      return;
    }
    toast({
      title: "Welcome to the Club.",
      description: `Check ${email} for your 15% code.`,
    });
    setEmail("");
  };

  return (
    <section className="relative bg-[#c60d0d] text-white py-16 overflow-hidden">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="relative max-w-[1000px] mx-auto px-4 md:px-8 text-center">
        <div className="text-[11px] tracking-[0.32em] font-bold uppercase mb-4">Join the Club</div>
        <h2 className="text-3xl md:text-5xl font-black tracking-tight leading-[1.02]">
          GET 15% OFF YOUR FIRST DROP.
        </h2>
        <p className="mt-4 text-white/85 max-w-lg mx-auto text-[15px]">
          Early access to new colors, restocks, and members-only bundles. Discreet, always.
        </p>
        <form
          onSubmit={submit}
          className="mt-8 max-w-lg mx-auto flex items-center bg-white overflow-hidden"
        >
          <Mail size={18} className="ml-4 text-black/40" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            className="flex-1 px-3 py-4 bg-transparent text-black outline-none text-[14px] placeholder:text-black/40"
          />
          <button
            type="submit"
            className="bg-black hover:bg-[#1a1a1a] transition text-white px-5 py-4 text-[12px] tracking-[0.18em] font-bold uppercase flex items-center gap-2"
          >
            Join <ArrowRight size={14} />
          </button>
        </form>
      </div>
    </section>
  );
}
